import { createApiClient } from '@room/frontend-sdk';
import type { APIResponse } from '@room/shared-ui';

const apiClient = createApiClient({
  baseURL: '/api',
});

const logApiError = (method: string, url: string, error: unknown) => {
  const errorInfo = {
    timestamp: new Date().toISOString(),
    method,
    url,
    error: (error as Error)?.message || String(error),
  };
  console.error('[API Error]', errorInfo);
};

export const api = {
  async get<T = unknown>(url: string): Promise<T> {
    try {
      return await apiClient.get<T>(url);
    } catch (error) {
      logApiError('GET', url, error);
      throw error;
    }
  },
  async post<T = unknown>(url: string, data?: unknown): Promise<T> {
    try {
      return await apiClient.post<T>(url, data);
    } catch (error) {
      logApiError('POST', url, error);
      throw error;
    }
  },
  async put<T = unknown>(url: string, data?: unknown): Promise<T> {
    try {
      return await apiClient.put<T>(url, data);
    } catch (error) {
      logApiError('PUT', url, error);
      throw error;
    }
  },
  async patch<T = unknown>(url: string, data?: unknown): Promise<T> {
    try {
      return await apiClient.patch<T>(url, data);
    } catch (error) {
      logApiError('PATCH', url, error);
      throw error;
    }
  },
  async delete<T = unknown>(url: string): Promise<T> {
    try {
      return await apiClient.delete<T>(url);
    } catch (error) {
      logApiError('DELETE', url, error);
      throw error;
    }
  },
};

export const pluginAPI = {
  getMyPlugins: () => api.get<APIResponse<{ plugins: any[] }>>('/developer/plugins/my-plugins'),
  getUserRegistry: () => api.get<APIResponse<{ plugins: Array<{ pluginId: string; state: string }> }>>('/plugins/registry'),
};

export const pipelineAPI = {
  getSnapshot: () => api.get<APIResponse<any>>('/developer/pipeline'),
};

export const marketplaceAPI = {
  listPlugins: () => api.get<APIResponse<{ plugins: any[] }>>('/marketplace/plugins'),
};
